export default __webpack_public_path__ + "static/media/image-3.b2268135.jpg";